import React from 'react';
import { motion } from 'framer-motion';
import { HeartIcon } from 'lucide-react';
interface FloatingHeart {
  left: number;
  size: number;
  delay: number;
  duration: number;
  drift: number;
  opacity: number;
  filled: boolean;
}
const HEARTS: FloatingHeart[] = [{
  left: 4,
  size: 40,
  delay: 0,
  duration: 14,
  drift: 24,
  opacity: 0.5,
  filled: true
}, {
  left: 13,
  size: 22,
  delay: 3.4,
  duration: 16,
  drift: -18,
  opacity: 0.35,
  filled: false
}, {
  left: 22,
  size: 30,
  delay: 1.6,
  duration: 12.5,
  drift: 20,
  opacity: 0.4,
  filled: true
}, {
  left: 31,
  size: 20,
  delay: 5.2,
  duration: 15,
  drift: -22,
  opacity: 0.3,
  filled: false
}, {
  left: 40,
  size: 34,
  delay: 2.4,
  duration: 17,
  drift: 14,
  opacity: 0.25,
  filled: true
}, {
  left: 49,
  size: 22,
  delay: 6.4,
  duration: 13.5,
  drift: -12,
  opacity: 0.35,
  filled: false
}, {
  left: 57,
  size: 28,
  delay: 0.8,
  duration: 16.5,
  drift: 20,
  opacity: 0.25,
  filled: true
}];

/** Decorative hearts rising behind the opening — the brand-love motif. */
export function FloatingHearts() {
  return <div className="pointer-events-none absolute inset-0 overflow-hidden" aria-hidden="true" data-id="element-273" data-mp="ncioknhp3y9q">
      {HEARTS.map(heart => <motion.div key={`${heart.left}-${heart.delay}`} className="absolute bottom-[-8%]" style={{
      left: `${heart.left}%`
    }} initial={{
      y: 0,
      x: 0,
      opacity: 0
    }} animate={{
      y: ['0%', '-125vh'],
      x: [0, heart.drift, -heart.drift * 0.6, 0],
      opacity: [0, heart.opacity, heart.opacity, 0]
    }} transition={{
      duration: heart.duration,
      delay: heart.delay,
      repeat: Infinity,
      ease: 'linear',
      times: [0, 0.12, 0.82, 1]
    }} data-id="element-274" data-mp="jcrtw8p1sxzx">
          <HeartIcon className={heart.filled ? 'fill-current text-[var(--brand)]' : 'text-[var(--brand)]'} style={{
        width: heart.size,
        height: heart.size
      }} strokeWidth={heart.filled ? 0 : 2.4} data-id="element-275" data-mp="1b3xlu1um7pe4" />
        </motion.div>)}
    </div>;
}